import React, { useState, useEffect, useContext } from 'react';
import '../App.css';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { GrupoContext } from '../GrupoContext';
import Sidebar from '../componenteExtra/SidebarStaff';
import SessionManager from '../componenteExtra/SessionManager';

const AsignacionesEnRevision = () => {
    const { grupo: staffName } = useContext(GrupoContext);
    const [activities, setActivities] = useState([]);
    const [nombreGet, setNombreGet] = useState('');
    const navigate = useNavigate();

    const token = localStorage.getItem("access_token");

    useEffect(() => {
        // Restaurar el estado de nombreGet desde localStorage
        const savedNombreGet = localStorage.getItem('nombre_get');
        if (savedNombreGet) {
            setNombreGet(savedNombreGet);
        }

        // Cargar actividades si el nombre está disponible
        if (savedNombreGet) {
            fetchActivities(savedNombreGet);
        }
    }, []);

    useEffect(() => {
        // Guardar el nombre en localStorage si cambia
        if (nombreGet) {
            localStorage.setItem('nombre_get', nombreGet);
        }
    }, [nombreGet]);

    const fetchActivities = async (nombre) => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_BACKEND_URL}/my_assignments3/${nombre}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            setActivities(response.data);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const totalActividades = activities.length;

    return (
        <div className="app">
            <SessionManager />
            <Sidebar />
            <div className="main-content">
                <div className="main-panel">
                    <h1>Actividades en revisión - {nombreGet}</h1>
                    <h2>Total Actividades: {totalActividades}</h2>
                    <p>Fase de revisión 2 = Líder del grupo | Fase de revisión 3 = Senior GET | Fase de revisión 4 = Solicitante</p>
                    <div className="activities-table-container">
                        <table className="activities-table">
                            <thead>
                                <tr>
                                    <th>Código de Proyecto</th>
                                    <th>Razón Social</th>
                                    <th>Filial</th>
                                    <th>Solicitante</th>
                                    <th>Tipo de trabajo</th>
                                    <th>Regulación</th>
                                    <th>Socio de auditoría</th>
                                    <th>Numero Grupo</th>
                                    <th>Rubro GET</th>
                                    <th>Nombre Actividad GET</th>
                                    <th>Jefe de Grupo</th>
                                    <th>Subrogante</th>
                                    <th>Fecha Inicio</th>
                                    <th>Fecha Termino</th>
                                    <th>Fecha Corte Auditoria</th>
                                    <th>Horas Trabajadas</th>
                                    <th>Fase de Revision</th>
                                </tr>
                            </thead>
                            <tbody>
                                {activities.map((activity, index) => (
                                    <tr key={index}>
                                        <td>{activity.codigo_proyecto}</td>
                                        <td>{activity.razon_social}</td>
                                        <td>{activity.filial}</td>
                                        <td>{activity.nombre_solicitante}</td>
                                        <td>{activity.tipo_solicitud}</td>
                                        <td>{activity.tipo_regulacion}</td>
                                        <td>{activity.encargado_auditoria}</td>
                                        <td>{activity.numero_grupo}</td>
                                        <td>{activity.rubro_get}</td>
                                        <td>{activity.nombre_actividad_get}</td>
                                        <td>{activity.jefe_grupo}</td>
                                        <td>{activity.subrogante}</td>
                                        <td>{activity.fecha_de_inicio ? new Date(activity.fecha_de_inicio).toLocaleDateString('es-ES') : ''}</td>
                                        <td>{activity.fecha_de_termino ? new Date(activity.fecha_de_termino).toLocaleDateString('es-ES') : ''}</td>
                                        <td>{activity.fecha_corte_auditoria ? new Date(activity.fecha_corte_auditoria).toLocaleDateString('es-ES') : ''}</td>
                                        <td>{activity.horas_get}</td>
                                        <td>{activity.estados_staff}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AsignacionesEnRevision;
